import { isNonEmptyArray } from '@/utils/checks'
import {
  MATCH_SPECIALIZATION_BOOST,
  DEWEIGHTED_SPECIALIZATION_BOOST,
  DEWEIGHTED_SPECIALIZATIONS
} from './constants'

export const centerMatchesSpecializations = (
  specializations: string[],
  treatmentFocus: string
): number => {
  if (!treatmentFocus) {
    return 0
  }

  if (
    DEWEIGHTED_SPECIALIZATIONS.includes(treatmentFocus) &&
    isNonEmptyArray(specializations) &&
    specializations?.includes(treatmentFocus)
  ) {
    return DEWEIGHTED_SPECIALIZATION_BOOST
  }

  return specializations?.some(
    (specialization) => treatmentFocus === specialization
  )
    ? MATCH_SPECIALIZATION_BOOST
    : 0
}
